import { defineActionCreators } from '../../../../infra/libs/redux-hardtyped/defineActionCreators'

export const modalExcluirCenarioActionCreators = defineActionCreators('modalExcluirCenario', {
  abrirModal: (id: number, nome: string) => ({ id, nome }),
  fecharModal: () => ({}),
})
